import i18n from 'modules/core/lib/i18n'

interface Props {
  value: string
  options: string[]
}

const validateEnum = ({ value, options }: Props) => {
  const isValid = options.includes(value)
  const message = isValid ? '' : i18n.t('importer_process.edition_step.validators.enum')

  return { isValid, message }
}

export default validateEnum
